"use client";

import Header from '@/components/Header';
import Footer from '@/components/Footer/Footer';
import Hero from '@/components/Hero';
import Programme from '@/components/Programme/Programme';
import DressCode from '@/components/DressCode/DressCode';
import RSVPForm from '@/components/RSPV/RSVPForm';
import PhotoVideoUpload from '@/components/PhotoVideoUpload/PhotoVideoUpload'; // ✅ NOUVEAU
import Cagnotte from '@/components/Cagnotte/Cagnotte';
import EnAttendantLeJourJ from '@/components/EnAttendantLeJourJ/EnAttendantLeJourJ';
import React, { useEffect, useState } from 'react';
import { apiService } from '@/services/api'

export default function Home() {
	const [ping, setPing] = useState('');

	const WEDDING_DATE = new Date('2025-12-04T22:00:00');
	const isAfterWedding = new Date() > WEDDING_DATE;

	useEffect(() => {
		apiService.ping()
			.then(response => {
				if (response.success && response.data) {
					setPing(response.data.message);
				}
			})
			.catch(() => setPing('Erreur de connexion au backend'));
	}, []);

	return (
		<main className="min-h-screen flex flex-col bg-[#f1ece0]">
			<Header />
			<Hero />

			{/* ✅ Section conditionnelle : RSVP avant le mariage, Upload après */}
			<section>
				<h2
					id={isAfterWedding ? "souvenirs" : "rsvp"}
					className="scroll-mt-20 sticky-title heading-secondary border-b font-monsieurLaDoulaise"
					style={{ background: 'linear-gradient(90deg, #b19872 20%, transparent 100%)' }}
				>
                <span className="text-[#ffffff] ml-[10px] md:ml-14 md:text-4xl">
                   {isAfterWedding ? "Vos souvenirs" : "Votre réponse"}
                </span>
				</h2>
				<div className="section-padding">
					{isAfterWedding ? <PhotoVideoUpload /> : <RSVPForm />}
				</div>
			</section>

			<section>
				<h2 id="programme" className="scroll-mt-20 sticky-title heading-secondary border-b font-monsieurLaDoulaise"
					style={{ background: 'linear-gradient(90deg, #b19872 20%, transparent 100%)' }}>
					<span className="text-[#ffffff] ml-[10px] md:ml-14 md:text-4xl">Programme</span>
				</h2>
				<div className="section-padding">
					<Programme />
				</div>
			</section>
			<section>
				<h2 id="cagnotte" className="scroll-mt-20 sticky-title heading-secondary border-b font-monsieurLaDoulaise"
					style={{ background: 'linear-gradient(90deg, #b19872 20%, transparent 100%)' }}>
					<span className="text-[#ffffff] ml-[10px] md:ml-14 md:text-4xl">Cagnotte</span>
				</h2>
				<div className="section-padding">
					<Cagnotte />
				</div>
			</section>
			<section>
				<h2 id="moodboard" className="scroll-mt-20 sticky-title heading-secondary border-b font-monsieurLaDoulaise"
					style={{ background: 'linear-gradient(90deg, #b19872 20%, transparent 100%)' }}>
					<span className="text-[#ffffff] ml-[10px] md:ml-14 md:text-4xl">Moodboard</span>
				</h2>
				<div className="section-padding">
					<DressCode />
				</div>
			</section>
			<section>
				<h2 id="en-attendant" className="scroll-mt-20 sticky-title heading-secondary border-b font-monsieurLaDoulaise"
					style={{ background: 'linear-gradient(90deg, #b19872 20%, transparent 100%)' }}>
					<span className="text-[#ffffff] ml-[10px] md:ml-14 md:text-4xl ">En attendant le jour J</span>
				</h2>
				<div className="section-padding">
					<EnAttendantLeJourJ />
				</div>
			</section>
			<Footer />
		</main>
	);
}
